export default "__VITE_PUBLIC_ASSET__0079295a__"